import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/reducers';
import { saveFilterData } from '../store/reducers/Stable/slice';
import useQuery from './useQuery';
const useUpdateFilterParams = () => {
    const query = useQuery();
    const dispatch = useAppDispatch();
    const [params, setParams] = useSearchParams();
    const filtersValue = useAppSelector((state) => state.stable.filtersValue);
    useEffect(() => {
        if (Object.keys(query).length === 0 && filtersValue) {
            setParams(filtersValue);
        }
        else if (filtersValue !== new URLSearchParams(query).toString()) {
            dispatch(saveFilterData(params.toString()));
        }
    }, [dispatch, query, filtersValue, setParams, params]);
};
export default useUpdateFilterParams;
